import { type Actions, ActionType } from './widget-templates.actions';
import { initialState, type State, widgetTemplateAdapter } from './widget-templates.state';

export function widgetTemplatesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_WIDGET_TEMPLATES: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_WIDGET_TEMPLATES_SUCCEEDED: {
            return widgetTemplateAdapter.setAll(action.payload.widgetTemplates, {
                ...state,
                isLoaded: true,
                isPending: false
            });
        }

        case ActionType.FETCH_WIDGET_TEMPLATES_FAILED: {
            return {
                ...state,
                isLoaded: false,
                isPending: false,
                error: action.payload.error
            };
        }

        case ActionType.RESET: {
            return { ...initialState };
        }

        default:
            return state;
    }
}
